module.exports = __webpack_public_path__ + "static/brand-huidu-dbae1fde4456727097da6fc20a9483b2.png";